import React, { useState } from 'react';
import Conversations from './Conversations';
import CriteriaList from './CriteriaList';
import Livraisons from './Livraisons';
import LivraisonsFinales from './LivraisonsFinales';

const Tabs = ({ task, filterFunc, comments, fetchData, microTaches, refetchMicroTaches, profileLetters, name, tab, notifMicrotache, isLoadingData }) => {
  const [activeTab, setActiveTab] = useState(tab);
  return (
    <div className="w-full flex flex-col">
      <ul className="list-none flex items-center justify-center gap-4 font-inter text-indigos font-normal w-full pt-12 border-b border-gryborder/60 max-md:flex-wrap max-md:gap-2 max-md:pt-6">
        <li
          className={`cursor-pointer text-center text-[13px] pt-1 pb-2 w-[28%] max-md:w-[45%] max-md:text-xs ${activeTab === 0 && "border-b-2 border-orange text-orange"
            }`}
          onClick={() => setActiveTab(0)}
        >
          Critères de validation
        </li>
        <li
          className={`flex justify-center cursor-pointer text-center pt-1 pb-2 text-[13px] w-[28%] max-md:w-[45%] max-md:text-xs indicator ${activeTab === 1 && "border-b-2 border-orange text-orange"
            }`}
          onClick={() => setActiveTab(1)}
        >
          Conversations
        </li>
        <li
          className={`cursor-pointer text-center text-[13px] pt-1 pb-2 w-[28%] max-md:w-[45%] max-md:text-xs ${activeTab === 2 && "border-b-2 border-orange text-orange"
            }`}
          onClick={() => setActiveTab(2)}
        >
          Livraisons
        </li>
        <li
          className={`cursor-pointer text-center text-[13px] pt-1 pb-2 w-[28%] max-md:w-[45%] max-md:text-xs ${activeTab === 3 && "border-b-2 border-orange text-orange"
            }`}
          onClick={() => setActiveTab(3)}
        >
          Livraisons finales
        </li>
      </ul>
      <div className='w-full flex justify-center'>
        <div className='w-[88%] max-md:w-full max-md:px-4'>
          {activeTab === 0 && (
            <CriteriaList
              task={task}
              microTaches={microTaches}
              refetchMicroTaches={refetchMicroTaches}
              notifMicrotache={notifMicrotache}
              isLoadingData={isLoadingData}
            />
          )}
          {activeTab === 1 && (
            <Conversations
              task={task}
              filterFunc={filterFunc}
              comments={comments}
              fetchData={fetchData}
              isLoadingData={isLoadingData}
            />
          )}
          {activeTab === 2 && (
            <Livraisons name={name} task={task} profileLetters={profileLetters} isLoadingData={isLoadingData} />
          )}
          {activeTab === 3 && (
            <LivraisonsFinales name={name} task={task} profileLetters={profileLetters} isLoadingData={isLoadingData} />
          )}
        </div>
      </div>
    </div>
  );
}

export default Tabs
